import './assets/main.css'
import './assets/tailwind.css';

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/stores/auth'
import { MotionPlugin } from '@vueuse/motion'



const app = createApp(App)

app.use(createPinia())
app.use(MotionPlugin)
app.use(router)

const authStore = useAuthStore()
authStore.checkAuth().finally(() => {
  app.mount('#app')
})
